import { Node } from 'reactflow';
import { ProcessorNodeData } from '../types/pipeline';

export const SYSTEM_INPUT_NODE: Node<ProcessorNodeData> = {
  id: 'input',
  type: 'inputProcessor', // SWRM-128: Use the new InputProcessorNode component
  position: { x: 100, y: 100 }, // Left-aligned like processor nodes (was 250 center-aligned)
  data: {
    step_id: 'input',
    name: 'input', // SWRM-128: Simplified name to match backend
    processor_name: 'input', // Must match InputProcessor for validation
    processor_type: 'UTILITY',
    required_input_keys: [],
    optional_input_keys: [],
    output_keys: [], // Dynamic - outputs depend on user-defined inputs
    config: {
      inputs: [
        // Default repository configuration inputs (can be deleted by user)
        {
          name: 'repository_name',
          type: 'string',
          display_type: 'text',
          description: 'Name of the repository/workspace',
          default_value: 'untitled-repo',
          required: true,
        },
        {
          name: 'repository_type',
          type: 'string',
          display_type: 'select',
          description: 'Type of repository to create or clone',
          default_value: '|*local_only|github_public|github_private|clone_github_public|clone_github_private',
          required: true,
        },
        {
          name: 'github_repo_url',
          type: 'string',
          display_type: 'text',
          description: 'GitHub repository URL (for clone operations)',
          required: false,
        },
        {
          name: 'github_branch',
          type: 'string',
          display_type: 'text',
          description: 'GitHub branch to use',
          default_value: 'main',
          required: false,
        },
        {
          name: 'github_token',
          type: 'string',
          display_type: 'text',
          description: 'GitHub personal access token',
          required: false,
        },
      ],
    },
    isLocked: true,
    description: 'Defines pipeline inputs - users configure what inputs the workflow accepts',
  },
  draggable: false,
  deletable: false,
  selectable: true,
};

